import { ArgType, KeyType, useFieldLookups } from "./useFieldLookups";
import {useMemo} from "react";

export const useFieldLookup = (
  serviceArg: ArgType,
  id: KeyType | null | undefined | null
): string | null | undefined => {

  const argument = useMemo(() => id === null || id === undefined ? [] : [id], [id]);

  const result = useFieldLookups(serviceArg, argument);
  return result === null || id === null || id == undefined || id === null ? null : result[id];
};
